import { debug } from 'console';
import LOG, { log } from '../../UTIL/LOG';
import CONQUER from '../CONQUER';

class User
{
    public avatarID?        : string;
 
    public username?        : string;
    public token?           : string;
    public type?            : 'DISCORD' | 'FACEBOOK' | 'TWITTER' | 'GOOGLE' | 'SNAPCHAT' | 'CONQUER' | 'WALLET' | 'GUEST' | 'USERNAME' | 'ADMIN';
    public email?           : string;
    public accessToken?     : string;
    public wallet?          : string;
}

namespace User {
    export const Fields:string[] = [
        `avatarID`, `username`, `token`, `type`, `email`, `accessToken`, `wallet`
    ];
}

export default User;